import { render, staticRenderFns } from "./visitTip.vue?vue&type=template&id=17818b32&scoped=true"
import script from "./visitTip.vue?vue&type=script&lang=js"
export * from "./visitTip.vue?vue&type=script&lang=js"
import style0 from "./visitTip.vue?vue&type=style&index=0&id=17818b32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17818b32",
  null
  
)

export default component.exports